export const ticketing = {
  namespaced: true,
  state: {
    masterBookSets: [], // GET /master_book_sets マスターブックのセットを抱えたmasterBooks
    masterBookSet: null, // GET /master_book_sets/:id 特定のマスターブックセット
    masterBooks: [], // GET /master_books マスターブック全体
    masterBook: [], // GET /master_books/:id 特定のマスターブック
    bookGroups: null, // GET /book_groups ユーザーの所有するブックグループ全体
    bookGroup: [], // GET /book_groups/:id 特定のブックグループ
    book: [], // GET /books/:id 特定のブック
    masterPass: [], // GET /master_passes/:id 特定のマスターパス
    pass: [], // GET /passes/:id 特定のパス
    masterSheet: [], // GET /master_sheets/:id 特定のマスターシート
    sheet: [], // GET /sheets/:id 特定のシート,
    frame: null,
    used_frames: [],
    unused_frames: [],
    storeCountOfMultiSheets: null,
    sheetMenus: null,
    issuedExternalMasterCouponIds: null,
    issuedExternalCouponStatusOfSheet: null,
    paymentMethods: null,
    paymentProcessInfo: null,
    paymentLaunchUrl: null,
  },
  getters: {
    masterBookSets(state) {
      return state.masterBookSets;
    },
    masterBookSet(state) {
      return state.masterBookSet;
    },
    masterBooks(state) {
      return state.masterBooks;
    },
    masterBook(state) {
      return state.masterBook;
    },
    bookGroups(state) {
      return state.bookGroups;
    },
    bookGroup(state) {
      return state.bookGroup;
    },
    book(state) {
      return state.book;
    },
    masterPass(state) {
      return state.masterPass;
    },
    pass(state) {
      return state.pass;
    },
    masterSheet(state) {
      return state.masterSheet;
    },
    sheet(state) {
      return state.sheet;
    },
    frame(state) {
      return state.frame;
    },
    used_frames(state) {
      return state.used_frames;
    },
    unused_frames(state) {
      return state.unused_frames;
    },
    storeCountOfMultiSheets(state) {
      return state.storeCountOfMultiSheets;
    },
    sheetMenus(state) {
      return state.sheetMenus;
    },
    issuedExternalMasterCouponIds(state)
    {
      return state.issuedExternalMasterCouponIds;
    },
    issuedExternalCouponStatusOfSheet(state)
    {
      return state.issuedExternalCouponStatusOfSheet;
    },
    paymentMethods(state)
    {
      return state.paymentMethods;
    },
    paymentProcessInfo(state)
    {
      return state.paymentProcessInfo;
    },
    paymentLaunchUrl(state)
    {
      return state.paymentLaunchUrl;
    },
  },
  mutations: {
    setMasterBookSets(state, masterBookSets) {
      state.masterBookSets = masterBookSets;
    },
    setMasterBookSet(state, masterBookSet) {
      state.masterBookSet = masterBookSet;
    },
    setMasterBooks(state, masterBooks) {
      state.masterBooks = masterBooks;
    },
    setMasterBook(state, masterBook) {
      state.masterBook = masterBook;
    },
    setbookGroups(state, bookGroups) {
      state.bookGroups = bookGroups;
    },
    setbookGroup(state, bookGroup) {
      state.bookGroup = bookGroup;
    },
    setBook(state, book) {
      state.book = book;
    },
    setMasterPass(state, masterPass) {
      state.masterPass = masterPass;
    },
    setPass(state, pass) {
      state.pass = pass;
    },
    setMasterSheet(state, masterSheet) {
      console.log("setMasterSheet :>> ", masterSheet);
      state.masterSheet = masterSheet;
    },
    setSheet(state, sheet) {
      state.sheet = sheet;
    },
    setFrame(state, frame) {
      console.log("frame :>> ", frame);
      console.log("state.frame :>> ", state.frame);

      state.frame = frame;
      console.log("state.frame :>> ", state.frame);
    },
    setFrames(state, frames) {
      state.frame = frames.frame;
      state.used_frames = frames.used_frames;
      state.unused_frames = frames.unused_frames;
    },
    setStoreCountOfMultiSheets(state, storeCountOfMultiSheets) {
      state.storeCountOfMultiSheets = storeCountOfMultiSheets;
    },
    setSheetMenus(state, menus) {
      state.sheetMenus = menus;
    },
    setIssuedExternalMasterCouponIds(state, issuedExternalMasterCouponIds) {
      state.issuedExternalMasterCouponIds = issuedExternalMasterCouponIds;
    },
    setIssuedExternalCouponStatusOfSheet(state, issuedExternalCouponStatusOfSheet) {
      state.issuedExternalCouponStatusOfSheet = issuedExternalCouponStatusOfSheet;
    },
    setPaymentMethods(state, paymentMethods) {
      state.paymentMethods = paymentMethods;
    },
    setPaymentProcessInfo(state, paymentProcessInfo) {
      state.paymentProcessInfo = paymentProcessInfo;
    },
    setPaymentLaunchUrl(state, paymentLaunchUrl) {
      state.paymentLaunchUrl = paymentLaunchUrl;
    },
  },
};
